/* import __COLOCATED_TEMPLATE__ from './permissions-request-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();